import { useContext, useEffect, useRef } from 'react';
import { PortalNavContext } from '../PortalNavContext/PortalNavContext';
import {
  LISTING,
  PATIENT,
  SET_LOADING,
  SET_PAGE,
  SET_PATIENT_NUMBER,
} from '../PortalNavContext/constants';

export const usePortalNav = () => {
  const { page, loading, dispatch } = useContext(PortalNavContext);
  const timeoutId = useRef<any>();

  useEffect(() => {
    if (timeoutId.current) clearTimeout(timeoutId.current);
    if (loading) {
      timeoutId.current = setTimeout(() => {
        dispatch({ type: SET_LOADING, payload: false });
      }, 200);
    }
    // return timeoutId.current && clearTimeout(timeoutId.current);
  }, [loading]);

  const triggerLoad = () => {
    dispatch({ type: SET_LOADING, payload: true });
  };

  const openListing = () => {
    if (page !== LISTING) triggerLoad();
    dispatch({ type: SET_PAGE, payload: LISTING });
  };

  const openPatient = (patientNumber: any) => {
    if (page !== PATIENT) triggerLoad();
    dispatch({ type: SET_PATIENT_NUMBER, payload: patientNumber });
    dispatch({ type: SET_PAGE, payload: PATIENT });
  };

  return { openListing, openPatient };
};
